






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Select<T extends { id: any; name: any }> extends Vue {
  @Prop() options!: T[]
  @Prop() selections!: T[]
  @Prop() title!: string
  @Prop() searchLabel!: string
  search = ''
  selected: T[] = this.selections

  get availableItems() {
    const selectedMap = this.selected.reduce<{ [key: number]: T }>(
      (acc, cur) => {
        return {
          ...acc,
          [cur.id]: cur
        }
      },
      {}
    )
    return this.options.filter(option => !selectedMap[option.id])
  }
  get allselected() {
    return this.availableItems.length === 0
  }
  get items() {
    const search = this.search.toLowerCase()

    if (!search) return this.availableItems

    return this.availableItems.filter(item => {
      const text = item.name.toLowerCase()
      return text.indexOf(search) > -1
    })
  }

  @Watch('selected')
  clearsearch() {
    this.search = ''
    this.update()
  }

  @Watch('selections')
  updateSelected() {
    this.selected = this.selections
    this.search = ''
  }

  update() {
    this.$emit('update:selection', this.selected)
  }
}
